import React from 'react'
import { Link } from 'react-router-dom'
import CSSTransition from 'react-transition-group/CSSTransition'
import { useRouter } from '../../hooks'
import styles from './SideMenu.module.css'

const SideMenu = ({ open, menu }) => {
  const router = useRouter()
  return (
    <CSSTransition in={open} timeout={300} classNames='fade-left' unmountOnExit>
      <div className={`${styles['side-menu-wrapper']} show-mobile`}>
        <ul className={styles['side-menu']}>
          {menu.map(item => {
            const selected = router.location.pathname === item.path
            return (
              <li
                key={item.name}
                className={selected ? styles['selected'] : ''}
              >
                <Link to={item.path}>{item.name}</Link>
              </li>
            )
          })}
          {menu.length > 0 && (
            <li
              className={
                router.location.pathname === '/live' ? styles['selected'] : ''
              }
            >
              <Link to='/live'>Live</Link>
            </li>
          )}
        </ul>
      </div>
    </CSSTransition>
  )
}

export default SideMenu
